export const MINDMAP_API_ROUTES = {
    GET_MINDMAP_LIST: '/mindmap/getmindmaplist',
    POST_NOTE_AND_BOOKMARK:'/mindmap/mindmapusercomment'
};
